import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';

import config from '../functions/config';



const UserProfile = () => {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      const sessionId = Cookies.get('sessionid'); // Get session ID from cookies
      if (!sessionId) {
        setError('User is not logged in. Please log in to view your profile.');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${config.BASE_URL}/api/profile/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Session-ID': sessionId, // Include session ID in the request headers
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user profile');
        }

        const data = await response.json();
        setUserData(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-danger">Error: {error}</div>;

  return (

    <div>

<nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">Library </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
            <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
            <li className="nav-item">
                <a className="nav-link" href="/userhome">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/profile">Profile</a>
              </li>
            
              <li className="nav-item">
                <a className="nav-link" href="/rentalhistory">Rented Books</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/purchasehistory">Purchase History</a>
              </li>
              <a href="/login" class="btn btn-danger">Logout</a>

            </ul>
          </div>
        </div>
      </nav>
      <div className="d-flex align-items-center justify-content-center min-vh-50 mt-5">
  <div className="container" style={{ maxWidth: "600px" }}>
    <h2 className="text-center mb-4">User Profile</h2>
    <div className="card shadow-lg">
      <div className="card-body">
        <h5 className="card-title text-center mb-3">Welcome, {userData.username}</h5>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <strong>Email:</strong> {userData.email}
          </li>
          <li className="list-group-item">
            <strong>First name:</strong> {userData.first_name}
          </li>
          <li className="list-group-item">
            <strong>Last name:</strong> {userData.last_name}
          </li>
          <li className="list-group-item">
            <strong>Phone:</strong> {userData.phone_number || 'Not provided'}
          </li>
          <li className="list-group-item">
            <strong>Joined On:</strong> {new Date(userData.date_joined).toLocaleDateString()}
          </li>
          <li className="list-group-item">
            <strong>Last Login:</strong> {new Date(userData.last_login).toLocaleDateString()}
          </li>
        </ul>
        <div className="text-center mt-4">

          <a href='/changepassword'><button className="btn btn-primary">Change Password</button> </a>
        </div>
      </div>
    </div>
  </div>
</div>

    </div>

  );
};

export default UserProfile;
